import React, {PropsWithChildren, useContext, useEffect, useState} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {getBankOfAmericaCaptureContext} from "../api/BankOfAmericaApi";

export interface BankOfAmericaFlexMicroformField {
    load: (fieldId: string) => void;
}

export interface BankOfAmericaCreateTokenOptions {
    expirationMonth: string;
    expirationYear: string;
}

export interface BankOfAmericaCreateTokenError {
    message: string;
}

export interface BankOfAmericaFlexMicroform {
    createField: (fieldName: string, parameters: any) => BankOfAmericaFlexMicroformField;
    createToken: (options: BankOfAmericaCreateTokenOptions, callback: (error: BankOfAmericaCreateTokenError, token: string) => void) => void;
}

export interface BankOfAmericaFlex {
    microform: (styles: any) => BankOfAmericaFlexMicroform;
}

interface BankOfAmericaContextState {
    getFlex: (context: string) => BankOfAmericaFlex;
    getInputStyles: () => any;
    fingerprintSessionId: string;
}

export const BankOfAmericaContext = React.createContext({} as BankOfAmericaContextState);

export const BankOfAmericaProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);
    const [fingerprintSessionId, setFingerprintSessionId] = useState<string>('');

    useEffect(() => {
        if (data.company && data.company.is_bank_of_america_enabled) {
            getBankOfAmericaCaptureContext()
                .then((context: any) => {
                    const bankOfAmericaScriptElement = document.createElement('script');
                    bankOfAmericaScriptElement.async = true;
                    bankOfAmericaScriptElement.src = `${context['clientLibrary']}`;
                    bankOfAmericaScriptElement.integrity = `${context['clientLibraryIntegrity']}`;
                    bankOfAmericaScriptElement.crossOrigin = 'anonymous';
                    document.body.appendChild(bankOfAmericaScriptElement);
                })

            const fingerprintSessionId = `${data.company.bank_of_america_merchant_id}_${new Date().getTime()}`;
            setFingerprintSessionId(fingerprintSessionId);
            const bankOfAmericaFingerprintScriptElement = document.createElement('script');
            bankOfAmericaFingerprintScriptElement.async = true;
            bankOfAmericaFingerprintScriptElement.src = `https://h.online-metrix.net/fp/tags.js?org_id=${data.company.bank_of_america_organization_id}&session_id=${data.company.bank_of_america_merchant_id}${fingerprintSessionId}`;
            document.body.appendChild(bankOfAmericaFingerprintScriptElement);
        }
    }, [data.company]);

    const getFlex = (context: string) => {
        return new ((window as any).Flex as any)(context);
    }

    const getInputStyles = () => {
        return {
            'input': {
                'font-family': "'Source Sans Pro', sans-serif",
                color: 'rgba(0, 0, 0, 0.75)',
                'font-weight': '300',
                'font-size': '17px',
            },
            'invalid': {'color': 'rgba(217, 60, 55, 1)'},
            valid: {'color': '#88cc40'}
        };
    }

    return (
        <BankOfAmericaContext.Provider value={{getFlex: getFlex, getInputStyles: getInputStyles, fingerprintSessionId}}>
            {children}
        </BankOfAmericaContext.Provider>
    )
}